import React, { useContext, useEffect, useRef, useState } from "react";
import { ethers } from "ethers";
import { useBreakpointValue } from "@chakra-ui/react";

import {
  Box,
  Center,
  Grid,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import Reader from "./contracts/Reader.json";
import UsdcBalanceFetcher from "../wallet/UsdBalanceFetcher";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { formatAddress } from "../../utils/formatMetamask";
import VaultPriceFeed from "./contracts/VaultPriceFeed.json";
import DataCollarStatus from "../../api/DataCollarStatus";
import PositionsGrid from "./PositionsGrid";

import HorizontalPositionsGrid from "./HorizontalPositionsGrid";
import TokenValue from "../wallet/TokenValue";
import CollateralCard from "./CollateralCard";
import UsdceBalanceFetcher from "../wallet/UsdeBalanceFetcher";
import {
  readerAddress,
  usdc,
  usdc_e,
  link,
  wbtc,
  btc,
  weth,
  vaultAddress,
  usdt,
  uni,
  frax,
  providerUrl,
} from "../../config";
import { AppContext } from "../../AppContext";
import DisplayLiquidityValues from "./DisplayUsdcLiquidity";
import JakobWallet from "../../contracts/BlindfoldWalletV2.json";
import GetStarted from "../GetStarted";
import WalletFactoryInfo from "../wallet/WalletFactoryInfo";
import DataExecutionFees from "../../api/DataExecutionFees";
import UsdtBalanceFetcher from "../wallet/UsdtBalanceFetcher";
import WethLiquidityInfo from "../wallet/WethLiquidityInfo";
import WbtcLiquidityInfo from "../wallet/WbtcLiquidityInfo";
import LinkLiquidityInfo from "../wallet/LinkLiquidityInfo";
import TabSwitcher from "./TabSwitcher";
import GasGauge from "./../GasGauge";
import EthSignalsBar from "../../blindfold-api/EthSignalsBar";
import WbtcBalanceFetcher from "../wallet/WbtcBalanceFetcher";
import WethBalanceFetcher from "../wallet/WethBalanceFetcher";
import LoadingVideoPlayer from "../LoadingVideoPlayer";
import LinkBalanceFetcher from "../wallet/LinkBalanceFetcher";
import DataDeltaProfits from './../../api/DataDeltaProfits';
import FetchDeposits from "../wallet/FetchDeposits";
import DataBlockNumber from "../../api/DataBlockNumber";
import DataNetwork from "../../api/DataNetwork";
import LinkSignalBar from "../../blindfold-api/LinkSignalBar";
import BtcSignalsBar from './../../blindfold-api/BtcSignalsBar';

ChartJS.register(ArcElement, Tooltip, Legend);

const GmxPositions = ({
  //contractAddress,
  activeBalance,
  onTotalCollateralChange,
  updateTotalBalance,
  handleActiveBalanceUpdate,
}) => {
  const readerAbi = Reader.abi;
  const isMobile = useBreakpointValue({ base: true, md: false });

  const { fastestWebSocket, contractAddress } = useContext(AppContext);

  const [positionsDetails, setPositionsDetails] = useState([]);
  const [totalPositions, setTotalPositions] = useState(0);
  const [totalCollateral, setTotalCollateral] = useState(0);
  const [usdcBalance, setUsdcBalance] = useState(0);
  const [usdceBalance, setUsdceBalance] = useState(0);
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [wbtcBalance, setWbtcBalance] = useState(0);
  const [wethBalance, setWethBalance] = useState(0);
  const [linkBalance, setLinkBalance] = useState(0);
  const [tokenPrice, setTokenPrice] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [availableCollateral, setAvailableCollateral] = useState(0);
  const [utilizationRate, setUtilizationRate] = useState(0);
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [changeLimit, setChangeLimit] = useState(0.6);
  const [lossLimit, setLossLimit] = useState(0.25);
  const sellLimit = parseFloat(changeLimit);
  const _lossLimit = parseFloat(lossLimit);
  const [showDetails, setShowDetails] = useState(false);
  const [prices, setPrices] = useState({});
  const [reloadBalances, setReloadBalances] = useState(false);

  let tokenName;

  const usdcBalanceRef = useRef(null);
  const usdceBalanceRef = useRef(null);
  const usdtBalanceRef = useRef(null);
  const wbtcBalanceRef = useRef(null);
  const wethBalanceRef = useRef(null);
  const linkBalanceRef = useRef(null);

  const handleUsdcBalanceChange = (balance) => {
    console.log("USDC Balance:", balance);
    setUsdcBalance(balance);
  };

  const handleUsdceBalanceChange = (balance) => {
    console.log("USDC.e Balance:", balance);
    setUsdceBalance(balance);
  };

  const handleUsdtBalanceChange = (balance) => {
    console.log("USDT Balance:", balance);
    setUsdtBalance(balance);
  };

  const reloadStablecoinBalances = () => {
    if (usdcBalanceRef.current) usdcBalanceRef.current.reloadBalance();
    if (usdceBalanceRef.current) usdceBalanceRef.current.reloadBalance();
    if (usdtBalanceRef.current) usdtBalanceRef.current.reloadBalance();
    if (wbtcBalanceRef.current) wbtcBalanceRef.current.reloadBalance();
    if (wethBalanceRef.current) wethBalanceRef.current.reloadBalance();
    if (linkBalanceRef.current) linkBalanceRef.current.reloadBalance();
  };

  const provider = new ethers.providers.JsonRpcProvider(providerUrl);

  const tokenImages = {
    eth: "./weth.png",
    usdc: "./usdc.png",
    usdc_e: "./usdc.png", // Assuming USDC.e uses the same image as USDC
    link: "./chainlink.png",
    usdt: "./usdt.png",
    weth: "./weth.png", // Assuming WETH uses the same image as LINK
    btc: "./btc.png", // Placeholder image for BTC
    wbtc: "./btc.png",
  };

  const tokenImages2 = [
    { src: "/eth.png", alt: "Ethereum" },
    { src: "/btc.png", alt: "Bitcoin" },
    { src: "/chainlink-icon.png", alt: "Chainlink" },
    { src: "/uni2.png", alt: "Uniswap" },
  ];

  const checkPluginApproval = async () => {
    try {
      // const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
      const contract = new ethers.Contract(
        contractAddress,
        JakobWallet.abi,
        provider,
      );
      const positionRouterAddress =
        "0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868";

      const isApproved = await contract.isPluginApproved(
        contractAddress,
        positionRouterAddress,
      );
      console.log(`Plugin Approved`, isApproved);
      setIsApproved(isApproved);
    } catch (error) {
      console.error("Error checking Position Router plugin approval:", error);
    }
  };

  const collateralTokens = [
    link, // 1  LINK/USDC  | isLong = true
    usdc, // 2  USDC/LINK  | isLong = false
    link, // 3  LINK/LINK  | isLong = true
    link, // 4  LINK/LINK  | isLong = false
    weth, // 5  WETH/USDC  | isLong = true
    usdc, // 6  USDC/WETH  | isLong = false
    weth, // 7  WETH/WETH  | isLong = true
    weth, // 8  WETH/WETH  | isLong = false
    wbtc, // 9  WBTC/USDC  | isLong = true
    wbtc, // 10 WBTC/WETH  | isLong = false
    wbtc, // 11 WBTC/WBTC  | isLong = true
    wbtc, // 12 WBTC/BTC   | isLong = false
    usdc_e, // 13 USDC.e/LINK | isLong = false
    usdc, // 14 USDC/WBTC  | isLong = true
    usdt, // 15 USDT/WETH  | isLong = false
    weth, // 16 WETH/USDT  | isLong = true
    frax, // 17 FRAX/WETH  | isLong = false
    weth, // 18 WETH/FRAX  | isLong = true
    usdc_e, // usdc.e / WETH short
    usdc_e, // usdc.e / WETH long

    usdc, // usdc / weth  long
    usdt, // usdt / weth short
  ];

  const indexTokens = [
    usdc, // 1  LINK/USDC  | isLong = true
    link, // 2  USDC/LINK  | isLong = false
    link, // 3  LINK/LINK  | isLong = true
    link, // 4  LINK/LINK  | isLong = false
    usdc, // 5  WETH/USDC  | isLong = true
    weth, // 6  USDC/WETH  | isLong = false
    weth, // 7  WETH/WETH  | isLong = true
    weth, // 8  WETH/WETH  | isLong = false
    usdc, // 9  WBTC/USDC  | isLong = true
    wbtc, // 10 WBTC/WETH  | isLong = false
    wbtc, // 11 WBTC/WBTC  | isLong = true
    wbtc, // 12 WBTC/BTC   | isLong = false
    link, // 13 USDC.e/LINK | isLong = false
    wbtc, // 14 USDC/WBTC  | isLong = true
    weth, // 15 USDT/WETH  | isLong = false ✅ USDT collateral, WETH as index token
    usdt, // 16 WETH/USDT  | isLong = true ✅ USDT as index token
    weth, // 17 FRAX/WETH  | isLong = false
    frax, // 18 WETH/FRAX  | isLong = true
    weth, // usdc.e / WETH short
    weth, // usdc.e / WETH long

    weth, // usdc / weth long
    weth, // usdt / weth short
  ];

  const isLong = [
    true, // 1  LINK/USDC
    false, // 2  USDC/LINK
    true, // 3  LINK/LINK
    false, // 4  LINK/LINK
    true, // 5  WETH/USDC
    false, // 6  USDC/WETH
    true, // 7  WETH/WETH
    false, // 8  WETH/WETH
    true, // 9  WBTC/USDC
    false, // 10 WBTC/WETH
    true, // 11 WBTC/WBTC
    false, // 12 WBTC/BTC
    false, // 13 USDC.e/LINK
    true, // 14 USDC/WBTC
    false, // 15 USDT/WETH
    true, // 16 WETH/USDT
    false, // 17 FRAX/WETH
    true, // 18 WETH/FRAX
    false, // usdc.e / WETH short
    true, // usdc.e / WETH long

    true, // usdc / weth long
    true, // usdt / weth short
  ];

  const toggleDetails = () => {
    setShowDetails((prev) => !prev);
  };

  // fetch positions
  const handleGetPositions = async () => {
    try {
      const contract = new ethers.Contract(readerAddress, readerAbi, provider);
      const positionsData = await contract.getPositions(
        vaultAddress,
        contractAddress,
        collateralTokens,
        indexTokens,
        isLong,
      );
      console.log(positionsData);
      const details = parsePositionsData(positionsData);
      console.log(details);
      setPositionsDetails(details);
    } catch (err) {
      console.error(err);
    }
  };

  // Function to fetch token price
  const fetchPrice = async (tokenAddress) => {
    try {
      //const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);

      const routerContract = new ethers.Contract(
        VaultPriceFeed.address,
        VaultPriceFeed.abi,
        provider,
      );
      const tx = await routerContract.getPriceV1(tokenAddress, false, true);
      const scaleFactor = ethers.BigNumber.from("10").pow(27);
      const priceInWei = ethers.BigNumber.from(tx);
      const price = priceInWei.div(scaleFactor);
      return Number(price.toString()) / 1000;
    } catch (err) {
      console.error("Error fetching price:", err);
      return null;
    }
  };

  // Function to reload all data, including USDC balance, positions, and total collateral
  const handleReload = async () => {
    // reload collateral utilization rate
    calculateCollateralUtilizationRate();
    // Reload positions
    handleGetPositions();
    // Reload the USDC balance by triggering the UsdcBalanceFetcher component
    reloadStablecoinBalances();

    setReloadBalances((prev) => !prev); // Toggle state to trigger reload
    //reloadPrice();
    /** toast({
        title: "Reloading",
        description: "Fetching latest data...",
        status: "info",
        duration: 1000,
        isClosable: true,
        position: "bottom",
      }); */
  };

  const calculateCollateralUtilizationRate = () => {
    const usdc = parseFloat(usdcBalance) || 0;
    const usdce = parseFloat(usdceBalance) || 0;
    const usdt = parseFloat(usdtBalance) || 0;
    const used = parseFloat(totalCollateral) || 0;

    const available = usdc + usdce + usdt;
    const total = available + used;

    setTotalBalance(total.toFixed(2));
    setAvailableCollateral(available.toFixed(2));

    if (total > 0) {
      const utilization = (used / total) * 100;
      setUtilizationRate(utilization.toFixed(2));
    } else {
      setUtilizationRate(0);
    }

    if (onTotalCollateralChange) {
      onTotalCollateralChange(totalCollateral);
    }
  };

  const parsePositionsData = (positionsData) => {
    const details = [];
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });

    let totalCollateralSize = 0;

    for (let i = 0; i < positionsData.length / 9; i++) {
      const baseIndex = i * 9;
      const sizeInWei = ethers.BigNumber.from(positionsData[baseIndex]);
      const scaleFactor = ethers.BigNumber.from("10").pow(27);
      const formattedSize = sizeInWei.div(scaleFactor);
      const deltaInWei = ethers.BigNumber.from(positionsData[baseIndex + 8]);
      const formattedDelta = deltaInWei.div(scaleFactor);
      const adjustedDelta = Number(formattedDelta.toString()) / 1000;
      const collateralInWei = ethers.BigNumber.from(
        positionsData[baseIndex + 1],
      );
      const formattedCollateral = collateralInWei.div(scaleFactor);
      const entryPriceInWei = ethers.BigNumber.from(
        positionsData[baseIndex + 2],
      );
      const formattedAveragePrice = entryPriceInWei.div(scaleFactor);
      const adjustedSize = Number(formattedSize.toString()) / 1000;
      const adjustedCollateral = Number(formattedCollateral.toString()) / 1000;
      const adjustedAveragePrice =
        Number(formattedAveragePrice.toString()) / 1000;

      if (adjustedSize === 0) continue;

      totalCollateralSize += adjustedCollateral;

      // Calculate leverage
      const leverage =
        adjustedCollateral > 0
          ? (adjustedSize / adjustedCollateral).toFixed(2)
          : "N/A";

      // Calculate fees
      const openFee = parseFloat((adjustedSize * 0.001).toFixed(2)); // 0.1% of size
      const openCloseFees = parseFloat((openFee * 2).toFixed(2)); // Open + Close Fees

      const deltaPercentage = parseFloat(
        ((adjustedDelta / adjustedCollateral) * 100).toFixed(2),
      );

      const lastIncreasedTime = new Date(
        positionsData[baseIndex + 6] * 1000,
      ).toLocaleString("en-US", {
        timeZone: "America/Chicago",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      // 🛠️ Corrected Target Prices
      const targetSellPrice = parseFloat(
        isLong[i]
          ? adjustedAveragePrice * (1 + sellLimit / 100) // Long
          : adjustedAveragePrice * (1 - sellLimit / 100), // Short
      ).toFixed(2);

      const targetBuyPrice = parseFloat(
        isLong[i]
          ? adjustedAveragePrice * (1 - _lossLimit / 100) // Long
          : adjustedAveragePrice * (1 + _lossLimit / 100), // Short
      ).toFixed(2);

      // Calculate Potential Profit
      const positionProfit = adjustedSize * (1 + sellLimit / 100);
      const ps = positionProfit - adjustedSize;
      const potentialProfit = parseFloat((ps - openCloseFees).toFixed(2));

      // Adjust percentageChange based on position type
      let percentageChange = parseFloat(
        (
          ((tokenPrice - adjustedAveragePrice) / adjustedAveragePrice) *
          100
        ).toFixed(2),
      );

      if (!isLong[i]) {
        percentageChange = -percentageChange;
      }

      tokenName =
        collateralTokens[i] === link && indexTokens[i] === usdc
          ? "LINK/USDC"
          : collateralTokens[i] === usdt && indexTokens[i] === link
          ? "USDT/LINK"
          : collateralTokens[i] === usdc && indexTokens[i] === link
          ? "USDC/LINK"
          : collateralTokens[i] === link && indexTokens[i] === link
          ? "LINK/LINK"
          : collateralTokens[i] === usdc && indexTokens[i] === weth
          ? "USDC/WETH"
          : collateralTokens[i] === weth && indexTokens[i] === usdc
          ? "WETH/USDC"
          : collateralTokens[i] === weth && indexTokens[i] === weth
          ? "WETH/WETH"
          : collateralTokens[i] === wbtc && indexTokens[i] === usdt
          ? "WBTC/USDT"
          : collateralTokens[i] === usdt && indexTokens[i] === wbtc
          ? "USDT/WBTC"
          : collateralTokens[i] === wbtc && indexTokens[i] === usdc
          ? "WBTC/USDC"
          : collateralTokens[i] === wbtc && indexTokens[i] === weth
          ? "WBTC/WETH"
          : collateralTokens[i] === wbtc && indexTokens[i] === wbtc
          ? "WBTC/WBTC"
          : collateralTokens[i] === wbtc && indexTokens[i] === btc
          ? "WBTC/BTC"
          : collateralTokens[i] === usdc_e && indexTokens[i] === link
          ? "USDC.e/LINK"
          : collateralTokens[i] === usdc && indexTokens[i] === wbtc
          ? "USDC/WBTC"
          : collateralTokens[i] === usdt && indexTokens[i] === weth
          ? "USDT/WETH"
          : collateralTokens[i] === frax && indexTokens[i] === weth
          ? "FRAX/WETH"
          : collateralTokens[i] === weth && indexTokens[i] === usdt
          ? "WETH/USDT"
          : collateralTokens[i] === usdt && indexTokens[i] === usdc
          ? "USDT/USDC"
          : collateralTokens[i] === usdt && indexTokens[i] === wbtc
          ? "USDT/WBTC"
          : collateralTokens[i] === usdc_e && indexTokens[i] === weth
          ? "USDC.e/WETH"
          : collateralTokens[i] === usdt && indexTokens[i] === weth
          ? "USDT/WETH"
          : collateralTokens[i] === frax && indexTokens[i] === wbtc
          ? "FRAX/WBTC"
          : "Unknown Pair";

      details.push({
        positionIndex: i,
        name: tokenName,
        size: adjustedSize.toFixed(2),
        sizeWei: sizeInWei.toString(),
        collateral: adjustedCollateral.toFixed(2),
        collateralWei: collateralInWei.toString(),
        entryPrice: formatter.format(adjustedAveragePrice),
        currentPrice: tokenPrice,
        deltaPercentage: deltaPercentage.toFixed(2) + "%",
        lastIncreasedTime: lastIncreasedTime,
        hasProfit: positionsData[baseIndex + 7].toString(),
        delta: adjustedDelta,
        isLong: isLong[i],
        openClose: openCloseFees,
        sellPrice: targetSellPrice,
        buyPrice: targetBuyPrice,
        potential: potentialProfit.toFixed(2),
        change: percentageChange,
        leverage: leverage,
      });
    }

    setTotalPositions(details.length);
    setTotalCollateral(totalCollateralSize.toFixed(2));

    return details;
  };

  useEffect(() => {
    const loadPositions = async () => {
      await handleGetPositions(); // make sure this is async
      setIsLoading(false); // 👈 Only after position data is available
    };

    loadPositions();

    const intervalId = setInterval(() => {
      handleGetPositions();
    }, 20000); // 20 seconds

    return () => clearInterval(intervalId);
  }, [contractAddress]);

  useEffect(() => {
    // Notify parent component of totalCollateral change
    if (onTotalCollateralChange) {
      onTotalCollateralChange(totalCollateral);
    }
  }, [totalCollateral, onTotalCollateralChange, contractAddress]);

  // Fetch prices for each index token
  useEffect(() => {
    const fetchAllPrices = async () => {
      const newPrices = {};

      for (const position of positionsDetails) {
        const indexTokenAddress =
          indexTokens[position.positionIndex] === link
            ? link
            : indexTokens[position.positionIndex] === weth
            ? weth
            : indexTokens[position.positionIndex] === uni
            ? uni
            : indexTokens[position.positionIndex] === wbtc
            ? wbtc
            : null;

        if (indexTokenAddress) {
          const price = await fetchPrice(indexTokenAddress);
          newPrices[position.positionIndex] = price;
        }
      }

      setPrices(newPrices);
    };

    fetchAllPrices();
  }, [positionsDetails, contractAddress]);

  useEffect(() => {
    const usdc = parseFloat(usdcBalance) || 0;
    const usdce = parseFloat(usdceBalance) || 0;
    const usdt = parseFloat(usdtBalance) || 0;
    const usedCollateral = parseFloat(totalCollateral) || 0;

    // Stablecoin-only available balance
    const availCol = usdc + usdce + usdt;

    // Total balance includes stablecoins + used collateral
    const tb = availCol + usedCollateral;

    // Save unrounded values for internal use; only round for display
    setTotalBalance(tb.toFixed(2));
    setAvailableCollateral(availCol.toFixed(2));

    // Calculate utilization
    if (tb > 0) {
      const utilization = (usedCollateral / tb) * 100;
      setUtilizationRate(utilization.toFixed(2));
    } else {
      setUtilizationRate(0);
    }
  }, [
    usdcBalance,
    usdceBalance,
    usdtBalance,
    totalCollateral,
    contractAddress,
  ]);

  // Update collateral utilization whenever `usdcBalance`, `totalCollateral`, or `handleReload` changes
  useEffect(() => {
    calculateCollateralUtilizationRate();
  }, [
    usdcBalance,
    usdceBalance,
    usdtBalance,
    totalCollateral,
    contractAddress,
  ]);

  useEffect(() => {
    checkPluginApproval();
  }, [contractAddress]);

  return (
    <>
      {/**<DataChangeLimit onDataFetched={handleChangeData} /> */}
      {isLoading ? (
        <Center minH="700px" w="100%" bg="black" p={6}>
          <VStack spacing={2}>
            <Text fontFamily={"Sentinel"} fontSize="sm" mb={8} color="white">
              Loading...
            </Text>
            <LoadingVideoPlayer />
          </VStack>
        </Center>
      ) : (
        <>
          <Wrap
            //mt={1}

            //mb={2}
            //p={1}
            h="100%"
            minHeight="400px"
            w="100%"
            //justify="center"
            align="stretch"
          >
            <WrapItem
              shadow="md"
              borderWidth="1px"
              //borderRadius="md"
              //w="100%"
              //w="100%"
              //p={1}
              border="1px solid gray"
              justify="center"
              //maxWidth="600px"
              //mb={1}
              bg="gray.50"
              h="100%"
              flex={{ base: "1 0 100%", md: "1 25%" }}
              minH="730px"
              //flex="1 0 20%"
            >
              <VStack p={0} w="100%" justify="center">
                <CollateralCard
                  wbtcBalance={wbtcBalance}
                  wethBalance={wethBalance}
                  linkBalance={linkBalance}
                  activeBalance={activeBalance}
                  availableCollateral={availableCollateral}
                  totalPositions={totalPositions}
                  totalCollateral={totalCollateral}
                  utilizationRate={utilizationRate}
                  handleReload={handleReload}
                />

                <Tabs
                  size="sm"
                  w="100%"
                  variant={"line"}
                  bg="gray.200"
                  border="1px solid dodgerblue"
                >
                  <TabList>
                    <Tab fontSize="sm" fontFaily="Sentinel-light">
                      Balance
                    </Tab>
                    <Tab fontSize="sm" fontFaily="Sentinel-light">
                      Status
                    </Tab>
                    <Tab fontSize="sm" fontFaily="Sentinel-light">
                      Liquidity
                    </Tab>
                    <Tab fontSize="sm" fontFaily="Sentinel-light">
                      Info
                    </Tab>
                    <Tab>Earnings</Tab>
                  </TabList>

                  <TabPanels fontFamily="Sentinel">
                    <TabPanel minHeight="400px" p={0}>
                      <TokenValue
                        onActiveBalanceUpdate={handleActiveBalanceUpdate}
                        updateTotalBalance={updateTotalBalance}
                        totalPositions={totalPositions}
                        totalCollateral={totalCollateral}
                        reloadBalances={reloadBalances}
                      />
                    </TabPanel>

                    <TabPanel minHeight="400px" p={0}>
                      <DataCollarStatus />
                    </TabPanel>
                    <TabPanel minHeight="400px" p={0}>
                      <DisplayLiquidityValues />
                      <WethLiquidityInfo />
                      <WbtcLiquidityInfo />
                      <LinkLiquidityInfo />
                    </TabPanel>
                    <TabPanel minHeight="400px" p={0}>
                      <Tabs variant="enclosed" size="sm" isFitted>
                        <TabList mb="1em">
                        
                          <Tab>Fees</Tab>
                          <Tab>Network</Tab>
                          <Tab>Settings</Tab>
                        </TabList>

                        <TabPanels>
                        
                          <TabPanel p={0}>
                            <DataExecutionFees />
                          </TabPanel>
                          <TabPanel p={1}>
                            <DataNetwork/>
                          </TabPanel>
                          <TabPanel p={0}>
                            <WalletFactoryInfo />
                          </TabPanel>
                        </TabPanels>
                      </Tabs>
                    </TabPanel>
                    {/**<TabPanel minHeight="400px" p={0}>
                    <FetchDeposits/>
                    </TabPanel> */}
                    <TabPanel p={0}>
                            <DataDeltaProfits/>
                          </TabPanel>
                  </TabPanels>
                </Tabs>

                {/**<LiquidityGrid /> */}
              </VStack>
            </WrapItem>
            <WrapItem
              bg='Background'
              fontFamily="Sentinel-light"
              border="1px solid gray"
              flex={{ base: "1 0 100%", md: "1 60%" }}
              //shadow="lg"
              minH="730px"
              h="100%"
              maxW="100%"
              mr="1px" // ✅ this creates the desired 1px space
            >
              <VStack w="100%" spacing={1}>
              <BtcSignalsBar/>
                <EthSignalsBar />
                <LinkSignalBar/>
                
                {/**<HStack w="100%" justify="center" mt={1} mb={1}>
      <Text as="b">Positions ({totalPositions})</Text>
      <IconButton
        size="xs"
        variant="outline"
        bg="white"
        colorScheme="messenger"
        icon={<RepeatIcon />}
        onClick={handleReload}
        aria-label="Reload"
      />
    </HStack> */}

                {/* Display 2x2 Grid of Token Images if no positions */}
                {totalPositions === 0 && (
                  <VStack spacing={2} mt={8} w="100%" minHeight={"133px"}>
                    <Grid
                      templateColumns={{
                        base: "repeat(2, 1fr)",
                        md: "repeat(4, 1fr)",
                      }}
                      gap={4}
                      w="100%"
                    >
                      {tokenImages2.map((token, index) => (
                        <Image
                          key={index}
                          src={token.src}
                          alt={token.alt}
                          boxSize="50px"
                          mx="auto"
                        />
                      ))}
                    </Grid>
                    <Text mt={3} fontSize="sm" color="gray.500">
                      No active positions found...
                    </Text>
                    {!isApproved && <GetStarted />}
                  </VStack>
                )}

                {/** Desktop display */}
                <Box w="100%" mb={1} mt={2} minHeight="100px">
                  {isMobile ? (
                    <PositionsGrid
                      positionsDetails={positionsDetails}
                      collateralTokens={collateralTokens}
                      indexTokens={indexTokens}
                      prices={prices}
                      tokenImages={tokenImages}
                      tokenName={tokenName}
                      link={link}
                      usdc={usdc}
                      usdc_e={usdc_e}
                      weth={weth}
                      wbtc={wbtc}
                      btc={btc}
                      showDetails={showDetails}
                      toggleDetails={toggleDetails}
                      formatAddress={formatAddress}
                      sellLimit={sellLimit}
                      _lossLimit={_lossLimit}
                      totalPositions={totalPositions}
                      totalCollateral={totalCollateral}
                      utilizationRate={utilizationRate}
                      usdcBalance={usdcBalance}
                      usdceBalance={usdceBalance}
                      handleReload={handleReload}
                    />
                  ) : (
                    <HorizontalPositionsGrid
                      positionsDetails={positionsDetails}
                      collateralTokens={collateralTokens}
                      indexTokens={indexTokens}
                      prices={prices}
                      tokenImages={tokenImages}
                      tokenName={tokenName}
                      link={link}
                      usdc={usdc}
                      usdc_e={usdc_e}
                      weth={weth}
                      wbtc={wbtc}
                      btc={btc}
                      showDetails={showDetails}
                      toggleDetails={toggleDetails}
                      formatAddress={formatAddress}
                      sellLimit={sellLimit}
                      _lossLimit={_lossLimit}
                      totalPositions={totalPositions}
                      totalCollateral={totalCollateral}
                      utilizationRate={utilizationRate}
                      usdcBalance={usdcBalance}
                      usdceBalance={usdceBalance}
                      handleReload={handleReload}
                    />
                  )}
                </Box>

                {/* Tabs Full Width */}
                <Box w="100%">
                  <TabSwitcher />
                </Box>
              </VStack>

              {/* Balance Fetchers */}
              <UsdcBalanceFetcher
                ref={usdcBalanceRef}
                onUsdcBalance={handleUsdcBalanceChange}
              />
              <UsdceBalanceFetcher
                ref={usdceBalanceRef}
                onUsdceBalance={handleUsdceBalanceChange}
              />
              <UsdtBalanceFetcher
                ref={usdtBalanceRef}
                onUsdtBalance={handleUsdtBalanceChange}
              />

              <WbtcBalanceFetcher
                ref={wbtcBalanceRef}
                onWbtcBalance={(usdValue) => {
                  console.log("WBTC USD Value:", usdValue);
                  setWbtcBalance(parseFloat(usdValue));
                }}
              />

              <WethBalanceFetcher
                ref={wethBalanceRef}
                onWethBalance={(usdValue) => {
                  console.log("WETH USD Value:", usdValue);
                  setWethBalance(parseFloat(usdValue));
                }}
              />

              <LinkBalanceFetcher
                ref={linkBalanceRef}
                onLinkBalance={(usdValue) => {
                  console.log("LINK USD Value:", usdValue);
                  setLinkBalance(parseFloat(usdValue));
                }}
              />
            </WrapItem>
          </Wrap>
        </>
      )}
    </>
  );
};

export default GmxPositions;
